let menu = $('.main-menu');

function clickMenuButton() {
  let action = $(this).data("action");
  if (action == "toggle-menu" && menu.attr("aria-hidden") == "false" || action == "close-menu"){
    menu.attr("aria-hidden", "true");
  } else if (action == "toggle-menu") {
    menu.attr("aria-hidden", "false");
  }
}

function clickMenuLink() {
  // scroll main scroller
  let mainScroller = $('.wrapper .scroller'),
    scrollTop = mainScroller.scrollTop(),
    targetTop = $($(this).attr("href")).offset().top + scrollTop,
    distance = Math.abs(targetTop - scrollTop);
    if (distance > 5000) distance = 5000;
  mainScroller.animate({
    scrollTop: targetTop + 'px',
  }, 500 + distance / 5, 'swing');
  menu.find(".close button").click();

  // close current scroller
  $(".over[aria-hidden='false'] button.article-controller").click();

  return false;
}

export default {

  init: function() {
    $('[aria-controls="main-menu"]').on("click", clickMenuButton);
    $('.main-menu a').on("click", clickMenuLink);
  },

}
